<mat-card class="team-info" aria-label="Team contact information" data-qa-id="contactcard">
    <mat-card-content class="team-info__content-container">
        <div class="team-info__title">{{ title }}</div>

    @if (error && !loading) {
        <div class="team-info__error" role="alert" aria-live="assertive">
            <p>Unable to load contacts. Please try again later.</p>
        </div>
    }

    <div
        class="team-info__content-wrapper"
        novaSkeletonLoader
        [isLoading]="loading"
        [repeat]="skeletonRowCount"
        width="rand"
        height="28px"
        className="team-info__skeleton-row">
        @if (!loading && !error) {
            <div class="team-info__content">
            @for (contact of contacts; track contact.label; let i = $index) {
                <div
                    class="team-info__row"
                    [attr.data-qa-id]="contactQaIds[i] ?? ''">
                    <span class="team-info__label">{{ contact.label }}</span>

                    @if (hasValidContactName(contact)) {
                        <span class="team-info__value">
                            @if (contact.email) {
                                <mat-icon class="team-info__email-icon" aria-hidden="true">email</mat-icon>
                                <a
                                    class="team-info__name nova__link"
                                    [attr.href]="'mailto:' + contact.email"
                                    [attr.aria-label]="contact.label + ': ' + contact.name">
                                    {{ contact.name }}
                                </a>
                            } @else {
                                <span
                                    class="team-info__name team-info__name--not-listed"
                                    [attr.aria-label]="contact.label + ': ' + contact.name">
                                    {{ contact.name }}
                                </span>
                            }
                        </span>
                        <span
                            class="team-info__phone"
                            [class.team-info__phone--fallback]="isFallbackPhone(contact)">
                            @if (contact.phone) {
                                {{ contact.phone | phoneFormat }}
                            }
                        </span>
                    }
                </div>
            }
        </div>
        }
    </div>
    </mat-card-content>
</mat-card>
